// @flow
import { createAction } from 'redux-actions';
import type { ModerationAlertConfig } from './types';

export const fetchModerationAlertConfig = createAction(
  '@client/moderation-alerts/fetch',
  (clientId: Id) => clientId
);

export const storeModerationAlertConfig = createAction(
  '@client/moderation-alerts/store',
  (payload: Array<ModerationAlertConfig>) => payload,
  (_, clientId) => clientId
);

type ModerationAlertUpdateMeta = {
  clientId: Id,
  channel: string,
};
export const requestModerationAlertUpdate = createAction(
  '@client/moderation-alerts/update/request',
  (payload: ModerationAlertConfig) => payload,
  (_, meta: ModerationAlertUpdateMeta) => meta
);

export const receiveModerationAlertUpdate = createAction(
  '@client/moderation-alerts/update/response',
  (payload: ModerationAlertConfig) => payload,
  (_, meta: ModerationAlertUpdateMeta) => meta
);

export const clearModerationAlertUpdateStatus = createAction(
  '@client/moderation-alerts/update/clear',
  (payload: ModerationAlertUpdateMeta) => payload
);



// WEBPACK FOOTER //
// ./src/containers/client/alertConfigActions.js